// Air/truck rows carry one total_weight and no per-commodity split.
// Returns null when the row is outside the commodity filter, otherwise the
// group label plus whether its weight is unavailable. A mixed group inside an
// active filter is kept (the scorecards count it) but its weight can't be
// attributed to the selected commodity, so it is flagged rather than dropped.
const titleCase = (str) =>
  str ? str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) : '';

export const classifyAirTruckRow = (shipment, commodityFilter = '') => {
  const carried = String(shipment?.commodities || '').split(',').map((c) => c.trim()).filter(Boolean);
  const filter = String(commodityFilter || '').trim().toLowerCase();
  let weightUnavailable = false;
  if (filter) {
    const matches = carried.some((c) => c.toLowerCase() === filter);
    if (!matches) return null;
    weightUnavailable = carried.length > 1;
  }
  const label = carried.length ? carried.map(titleCase).join(' + ') : 'Unknown';
  return { label, carried, weightUnavailable };
};
